<template>
  <div class="tool-textarea">
    <Textarea
      class="emoji-textarea"
      :id="textareaId"
      :ref="textareaId"
      v-model="childText"
      @focus.stop="isOpenInputTool = true"
      @click.stop="isOpenInputTool = true"
      :counter="counter"
      v-bind="{ ...$attrs }"
      v-on="$listeners"
      hide-details="auto"
    />
    <div class="d-flex justify-space-between">
      <TextareaToolbox
        v-show="isOpenInputTool"
        class="tool"
        :class="{'has-counter': counter || isEmptyValue}"
        :variables="variables"
        @focus-textarea="focusTextarea"
        @add-emoji="addEmoji"
        @add-variable="addVariable"
      />
    </div>
  </div>
</template>

<script>
import Textarea from '@/components/form/Textarea.vue';
import TextareaToolbox from './TextareaToolbox.vue';

export default {
  name: 'TextareaEditor',
  inheritAttrs: false,
  model: {
    prop: 'text',
    event: 'input'
  },
  components: {
    Textarea,
    TextareaToolbox
  },
  props: {
    textareaId: {
      type: String,
      required: true
    },
    text: {
      type: String,
      default: ''
    },
    variables: {
      type: Array,
      default: () => null
    },
    counter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      childText: '',
      isOpenInputTool: false
    };
  },
  mounted() {
    this.childText = this.text;
    document.body.addEventListener('click', this.hideTool);
  },
  watch: {
    text(val) {
      this.childText = val;
    },
    childText(val) {
      this.$emit('input', val);
    }
  },
  beforeDestroy() {
    document.body.removeEventListener('click', this.hideTool);
  },
  computed: {
    isEmptyValue() {
      if (this.$attrs.rules) {
        return !this.text;
      }
      return false;
    }
  },
  methods: {
    // 關於 有 tool 的 textarea
    focusTextarea() {
      const textarea = this.$refs[this.textareaId];
      textarea.$children[0].$refs.input.focus();
    },
    addEmoji(emojiIcon) {
      const textarea = this.$refs[this.textareaId];
      const cursorPosition = textarea.$children[0].$refs.input.selectionStart;
      const insertStart = this.childText.slice(0, cursorPosition);
      const insertEnd = this.childText.slice(cursorPosition);

      this.childText = `${insertStart}${emojiIcon}${insertEnd}`;
      textarea.$children[0].$refs.input.focus();
    },
    addVariable(variable) {
      const textarea = this.$refs[this.textareaId];
      const cursorPosition = textarea.$children[0].$refs.input.selectionStart;
      const insertStart = this.childText.slice(0, cursorPosition);
      const insertEnd = this.childText.slice(cursorPosition);

      this.childText = `${insertStart}{{${variable}}}${insertEnd}`;
      textarea.$children[0].$refs.input.focus();
    },
    hideTool(e) {
      if (e.target.id !== this.textareaId) {
        this.isOpenInputTool = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.tool-textarea {
  position: relative;
}

::v-deep .text-input-tool {
  position: absolute;
  z-index: 999;
  right: 0;
  top: calc(100% + 2px);
}

::v-deep .has-counter, .error--text {
  .text-input-tool {
    top: calc(100% - 16px);
  }
}

</style>
